import React from "react";
import ServicePanel from "./PageComponents/ServicePanel";
import InfoPanel from "./PageComponents/InfoPanel";
import LatestNews from "./PageComponents/LatestNews";
import PartnerLogos from "./PageComponents/PartnerLogos";
import useDocumentMeta from "../hooks/useDocumentMeta";

const Main = () => {
  useDocumentMeta({
    title: "Optymalizacja Biznesu w Excelu",
    description: "Ekselowe.pl — audyty Excela, automatyzacja i makra, narzędzia na miarę, dashboardy i raporty, szkolenia oraz aplikacje webowe dla firm.",
  });

  return (
    <div className="main-container">
      <LatestNews />
      <ServicePanel />
      <PartnerLogos />
      <InfoPanel />
    </div>
  );
};

export default Main;
